var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-wrap mx-auto -px-2"},[_c('div',{staticClass:"w-full px-2"},[_c('router-view',{key:_vm.$route.fullPath})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }